import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

export function MetricCard({
	icon: Icon,
	label,
	value,
	detail,
	tone = "default",
}: {
	icon?: LucideIcon;
	label: string;
	value: string;
	detail?: string;
	tone?: "default" | "hero";
}) {
	return (
		<div
			className={cn(
				"min-w-0 rounded-lg p-5",
				tone === "hero" && "bg-primary-hover text-primary-foreground",
				tone === "default" && "surface-panel",
			)}
		>
			<div className="flex items-center justify-between">
				<p
					className={cn(
						"text-sm font-medium",
						tone === "hero" ? "text-sidebar-accent" : "text-muted-foreground",
					)}
				>
					{label}
				</p>
				{Icon !== undefined && (
					<Icon
						className={cn("size-5", tone === "hero" ? "text-sidebar-accent" : "text-primary")}
					/>
				)}
			</div>
			<p className="mt-4 break-words font-sans text-2xl font-semibold tracking-tight tabular-nums lg:text-3xl">
				{value}
			</p>
			{detail !== undefined && (
				<p
					className={cn(
						"mt-2 text-xs",
						tone === "hero" ? "text-sidebar-muted" : "text-muted-foreground",
					)}
				>
					{detail}
				</p>
			)}
		</div>
	);
}

export function StatePill({
	label,
	tone,
}: {
	label: string;
	tone: "green" | "amber" | "coral" | "muted";
}) {
	return (
		<span
			className={cn(
				"status-badge",
				tone === "green" && "bg-success/10 text-success",
				tone === "amber" && "bg-warning-soft text-warning",
				tone === "coral" && "bg-destructive/10 text-destructive",
				tone === "muted" && "bg-secondary text-muted-foreground",
			)}
		>
			{label}
		</span>
	);
}
